import { Box } from "@mui/material";

const About = (): JSX.Element => {
  return <Box>About</Box>;
};

export default About;
